import {useContext, useMemo} from 'react';
import {RouteContextValue, RouterContext} from '../routes/RouterProvider';

const useRouteHistory = (ignorePaths?: string[]): RouteContextValue => {
    const route = useContext(RouterContext);
    return useMemo(() => {
        if (
            !route.from ||
            (ignorePaths && ignorePaths.find(igPath => route.from.includes(igPath)))
        ) {
            route.from = '/overview';
        }

        return route;
    }, [route]);
};

export default useRouteHistory;
